// Port of api/fuel/app/classes/filter/package/games/play/package/games/winpercent.php
import F from 'offline/filter/constants'
export default {
	require: function(config, filter) { return config.ownerType === F.OWNER_USER && filter.play && filter.play.group },
	run: function(pkg, local) {
		pkg.record = local.record || {}
		return pkg
	}
}
